import { createReducer, on } from '@ngrx/store';
import { ResetStateFromRouter, SetActiveTabIndex } from 'src/app/shared/actions/eliqua.actions';
import { ActiveTabIndex } from 'src/app/shared/models/grid.model';
import { EditApifonIntegrationSystem } from '../actions/apifon-configuration.actions';
import { EditEliquaCXIntegrationSystem } from '../actions/eliqua-cx-configuration.actions';
import { EditEnboxIntegrationSystem } from '../actions/enbox-configuration.actions';
import {
  CreateNewIntegration,
  InitIntegrationDescriptionSuffix,
  InitIntegrationNameSuffix,
  SelectedIntegrationTypeChanged,
} from '../actions/integration-management-create-new.actions';
import { GetIntegrationTypesSuccess } from '../actions/integration-management-search.actions';
import { EditNeverbounceIntegrationSystem } from '../actions/neverbounce-configuration.actions';
import { EditOmniIntegrationSystem } from '../actions/omni-configuration.actions';
import { EditQcMessageAppIntegrationSystem } from '../actions/qc-message-app-configuration.actions';
import { EditSesIntegrationSystem } from '../actions/ses-configuration.actions';

export interface CreateNewIntegrationState {
  types: string[];
  integrationNameSuffix: string;
  integrationDescriptionSuffix: string;
  selectedIntegrationType: string;
  showDetailsTab: boolean;
}

const initialState: CreateNewIntegrationState = {
  types: [],
  integrationNameSuffix: '',
  integrationDescriptionSuffix: '',
  selectedIntegrationType: '',
  showDetailsTab: false,
};

export const CreateNewIntegrationReducer = createReducer(
  initialState,
  on(GetIntegrationTypesSuccess, (state, { response }) => ({
    ...state,
    types: response.payload.data,
  })),
  on(SelectedIntegrationTypeChanged, (state, { selectedIntegrationType: selectedType }) => ({
    ...state,
    selectedIntegrationType: selectedType,
  })),
  on(InitIntegrationNameSuffix, (state, { integrationNameSuffix }) => ({
    ...state,
    integrationNameSuffix,
  })),
  on(InitIntegrationDescriptionSuffix, (state, { integrationDescriptionSuffix }) => ({
    ...state,
    integrationDescriptionSuffix,
  })),
  on(EditEnboxIntegrationSystem, (state, { enboxData }) => ({
    ...state,
    selectedIntegrationType: enboxData.integrationConfig.integrationSystem,
  })),
  on(EditNeverbounceIntegrationSystem, (state, { neverbounceData }) => ({
    ...state,
    selectedIntegrationType: neverbounceData.integrationConfig.integrationSystem,
  })),
  on(EditApifonIntegrationSystem, (state, { apifonData }) => ({
    ...state,
    selectedIntegrationType: apifonData.integrationConfig.integrationSystem,
  })),
  on(EditQcMessageAppIntegrationSystem, (state, { qcMessageAppData }) => ({
    ...state,
    selectedIntegrationType: qcMessageAppData.integrationConfig.integrationSystem,
  })),
  on(EditEliquaCXIntegrationSystem, (state, { eliquaCXData }) => ({
    ...state,
    selectedIntegrationType: eliquaCXData.integrationConfig.integrationSystem,
  })),
  on(CreateNewIntegration, (state) => ({
    ...state,
    showDetailsTab: true,
  })),
  on(SetActiveTabIndex, (state, { activeTabIndex }) => ({
    ...state,
    showDetailsTab: activeTabIndex === ActiveTabIndex.DetailsComponent ? true : false,
    selectedIntegrationType:
      activeTabIndex === ActiveTabIndex.DetailsComponent ? state.selectedIntegrationType : '',
  })),
  on(EditSesIntegrationSystem, (state, { sesData }) => ({
    ...state,
    selectedIntegrationType: sesData.integrationConfig.integrationSystem,
  })),
  on(EditOmniIntegrationSystem, (state, { omniData }) => ({
    ...state,
    selectedIntegrationType: omniData.integrationConfig.integrationSystem,
  })),
  on(ResetStateFromRouter, () => ({
      ...initialState
  }))
);
